
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.819 29.453h20.363v-7.636c0-2.811-.995-5.21-2.983-7.199C37.21 12.63 34.81 11.635 32 11.635c-2.81 0-5.21.995-7.198 2.983-1.99 1.989-2.983 4.388-2.983 7.199v7.636zm33.09 3.818v22.91c0 1.06-.372 1.961-1.114 2.704-.743.742-1.644 1.113-2.704 1.113H12.91c-1.062 0-1.963-.371-2.706-1.113-.742-.743-1.113-1.644-1.113-2.704V33.27c0-1.06.37-1.962 1.113-2.704.743-.742 1.644-1.114 2.706-1.114h1.272v-7.636c0-4.88 1.75-9.068 5.25-12.568S27.123 4 32 4c4.88 0 9.068 1.75 12.568 5.25s5.25 7.689 5.25 12.568v7.636h1.273c1.06 0 1.961.372 2.704 1.114.742.742 1.114 1.644 1.114 2.704z","fill-rule":"nonzero"}})])
          )
        }
      }
    